export const STRETCH_COUNT = 37
export const FREE_STRETCH_COUNT = 8

export const OPERATING_SYSTEMS = ['macOS', 'Windows']

export const GITHUB_REPO = 'greenimpala/keybreak-releases'

export const FACEBOOK_URL = 'https://www.facebook.com/keybreak.co'

export const VERSION_GLOBAL = '__KEYBREAK_VERSION__'

// Pre-rendering pins the latest release into the HTML; the literal is only
// reached when that lookup fails.
const FALLBACK_VERSION = '2.3.1'

export const appVersion = () => globalThis[VERSION_GLOBAL] || FALLBACK_VERSION
